module.exports = __webpack_public_path__ + "img/care-offer-4.38a145e0.jpg";